import React from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import { theme } from 'theme';
import { IRestaurant } from 'features/home/types/homeTypes';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { isHolidaySurcharge } from 'submodules/OrderCore';
import { TextRed } from 'features/payment/components/AddInformation';

const deleteIconSize = 20;
const paddingdeleteButton = 5;
const deleteButtonWidth = deleteIconSize + paddingdeleteButton * 2 + 10;

const useStyles = makeStyles({
  cartFooterBox: {
    flex: 1,
  },
  cartFooter: {
    marginTop: 13,
    paddingTop: 19,
  },
  textSubtotal: {
    color: theme.palette.grey[800],
  },
  total: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '2.4rem',
    color: theme.palette.grey[900],
    flex: 1,
    marginRight: deleteButtonWidth,
    textAlign: 'right',
  },
  textGray: {
    fontSize: 14,
    lineHeight: '2.4rem',
    marginTop: 8,
    color: theme.palette.text.secondary,
  },
  textSurchargeFee: {
    fontSize: 14,
    lineHeight: '2.4rem',
    color: 'red',
  },
  textRed: {
    color: 'red',
  },
});

interface CartFooterProps {
  subTotal: number | string;
  restaurant: IRestaurant;
}

const CartFooter = ({ subTotal, restaurant }: CartFooterProps) => {
  const classes = useStyles();
  const holidaySurcharge = restaurant?.holidaySurcharge || {};
  const amountSurchargeFee = holidaySurcharge?.amount || 0;
  const { t } = useTranslation();

  const renderSurchargeFee = () => {
    const total = Number(subTotal);

    const result = ((total * Number(amountSurchargeFee)) / 100).toFixed(2);
    return `${restaurant && restaurant.currencySymbol ? restaurant.currencySymbol : '$'} ${
      result ? result : 0
    }`;
  };

  return (
    <Box className={classes.cartFooterBox}>
      <Box display="flex" className={classes.cartFooter}>
        <Typography className={classes.textSubtotal}>{t('Subtotal')}</Typography>
        <Typography className={classes.total}>
          {restaurant && restaurant.currencySymbol ? restaurant.currencySymbol : '$'}{' '}
          {subTotal || 0}
        </Typography>
      </Box>

      <Typography className={classes.textGray}>{t('Additional charges may apply')}.</Typography>

      {isHolidaySurcharge(restaurant) && (
        <Box display="flex">
          <TextRed>
            {restaurant?.holidaySurcharge?.name
              ? restaurant?.holidaySurcharge?.name
              : t('Holiday Surcharge Fee')}
          </TextRed>
          <Typography className={clsx(classes.total, classes.textRed)}>
            {renderSurchargeFee()}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CartFooter;
